import styled from "@emotion/styled";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle, faXmark } from '@fortawesome/free-solid-svg-icons';

const Icons = styled(FontAwesomeIcon)`
  width: 100%;
  height: 100%;
`;
const CrossButton = ({
  onCrossButtonChange,
  setBlackScreen,
  setQueryParams,
}) => {
  const params = new URLSearchParams(window.location.search);
  const deletedTerm = params.delete("q");
  
  const onClose = () => {
    onCrossButtonChange(false);
    setBlackScreen(false);
    setQueryParams(deletedTerm);
    window.history.replaceState(
      null,
      document.title,
      window.location.pathname + params.toString()
    );
    window.scrollTo({ top: 0, behavior: "smooth" });
    setQueryParams(params.toString());
  };

  return (
    <>
      <span className="fa-layers fa-fw custom-cross-icon" onClick={onClose}>
        <Icons icon={faCircle} style={{ color: "#336FE4" }} />
        <Icons icon={faXmark} size="xs" style={{ color: "white", height: '1.33331rem' }} />
      </span>
    </>
  );
};
export default CrossButton;
